<template>
    <div class="item-container">
        <input type="text" v-model="searchString" class="form-control" :placeholder="placeholder" @keyup.enter="search">
        <ion-icon name="search-outline" @click="search"></ion-icon>
    </div>
</template>

<script>
    import Url from "../tools/url";

    export default {
        props: {
            placeholder: String,
            fieldValue: String
        },

        data() {
            return {
                searchString: this.fieldValue
            };
        },

        methods: {
            search() {
                let url = new Url(document.location.href);
                url.setQueryParameter("search", this.searchString);
                url.removeQueryParameter("page");
                document.location.href = url.buildUrl();
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../../sass/variables";

    .item-container {
        position: relative;
    }

    input {
        padding-right: 30px;
        max-width: 250px;
        width: 100%;


        &:focus {
            border: none;
            outline: none;
            box-shadow: 0 0 5px 0 $primary-color;
        }
    }

    ion-icon {
        cursor: pointer;
        position: absolute;
        top: 0;
        right: 5px;
        height: 37px;
        width: 21px;
    }
</style>
